import React from "react";
import AlertDetailPage from "./AlertDetailPage";
import { useSearchParams, useNavigate } from 'react-router-dom';

function AlertDetailWrapper() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const alertId = searchParams.get('alertId');
  const alertType = searchParams.get('type');

  return (
    <AlertDetailPage
      alert={{ id: alertId, type: alertType }}
      onClose={() => {
        if (window.history && window.history.length > 1) {
          navigate(-1);
        } else {
          navigate("/dashboard");
        }
      }}
    />
  );
}

export default AlertDetailWrapper;